export default __webpack_public_path__ + "static/media/vbeeAI.e71a8909.svg";